import { DomeComponent, DomeManipulator, React } from "@lexriver/dome";
import { Settings } from "../../Settings";
import { ServerSettings } from "../server-queries/ServerSettings";
import { Link } from "./Link";

interface Attrs{
    
}

export class TextForCheckboxPolicy extends DomeComponent<Attrs>{
    render(){
        return (
            <span></span>
        )
    }
    afterRender(){
        this.scheduleUpdate()
    }

    async updateAsync(){
        await DomeManipulator.replaceAllChildrenAsync(this.rootElement,
                    <>
                Я ознакомлен(а) с&nbsp;<Link url={Settings.addPrefixForUrl(await ServerSettings.getOnlyValueAsync('url-policy'))}>условиями обработки персональных данных</Link> и 
                добровольно даю свое <Link url={Settings.addPrefixForUrl(await ServerSettings.getOnlyValueAsync('url-consent'))}>согласие</Link> на их обработку.
            </>
        )

    }
}
